import React, { useState } from 'react';
import { connect } from 'react-redux';
import SliderWrapper from 'jd-library/SliderWrapper';
import toastMessageActions from 'jd-library/toastMessageActions';
import useOnScroll from 'jd-library/useOnScroll';
import DocumentPreview from 'jd-library/DocumentPreview';
import historyHandler from "jd-library/historyHandler";
import style from './contractor-source-detail.scss';

const ContractorSourceDetail = (props) => {
    const[scrollEl,setScrollEl] = useState(null);
    const[scrolled,setScroll] = useState(false);
    const[showPreview,togglePreview] = useState(false);
    const[previewImage,updatePreviewImage] = useState([{}]);
    const showHideCb = (action) => {
        action == 'hide' && togglePreview(false);
    }
    const {
		contractorSourceList = [],
        isContractorSourcev1 = false,
        websiteLink = '',
	} = props;

    useOnScroll({
		callback : (e,scrollObj) => {
			if(scrollObj.currScroll.scrollTop){
				setScroll(true);
			}else{
			 	setScroll(false)
			}
		},
		element : !scrollEl ? null : scrollEl,
		deps: [scrollEl]
    })

    const checkImage = (image) => {
        updatePreviewImage([{
            previewUrl : image
        }])
        togglePreview(true);
    }

    const onUrlClick = (url) => {
        let redirectUrl = url;
        if (!(redirectUrl.indexOf("http://") == 0 || redirectUrl.indexOf("https://") == 0)) {
            redirectUrl = `https://` + redirectUrl;
        }
        window.open(redirectUrl, "_blank");
    }

    const DownloadFile = (e,data) => {
        e.stopPropagation();
        let url = `${window.location.origin}${data}`
        window.open(url, "_blank");
    }
    
    let dummyImageAppendUrl = '';
    if(typeof window !== 'undefined'){
        dummyImageAppendUrl = window.location.origin + "/documents/contractorv2";
    }

    let formElements = contractorSourceList.map((curVal,index) => {
        let image = dummyImageAppendUrl + curVal.screenShotUrl;

        return(
            <div className = {`${style['source-section']} ${index ? style['show-border'] : ''}`}>
                <div className = {style['source-title']}>Source URL {index + 1}</div>
                <div className = {style['source-ss-title']} onClick = {() => {onUrlClick(curVal.sourceUrl)}}>{curVal.sourceUrl}</div>
                <div className = {style['source-ss-holder']} onClick = {() => {
                    checkImage(image)}
                    }>
                    <div className = {`${style['source-ss-container']}`}>
                        <div className = {style['source-ss-text-holder']}>
                            <img className={style['img-holder']} src={image} />
                        </div>
                    </div>
                </div>
            </div>
        )
	})
    if(isContractorSourcev1){
        formElements = contractorSourceList.map((item,index) => {
            let urlHtm = '';
            if(item.websiteUrl){
                urlHtm = (<div className={style['data-list-url']} onClick = {(event) => {onUrlClick(item.websiteUrl)}}>
                        {item.websiteUrl}
                    </div>)
            }else if(item.download){
                urlHtm = (<div className={style['data-list-url']} onClick = {(event) => {
                    if(!item.isCallRecording){
                        DownloadFile(event,item.download)
                    }}}>
                        {"Download"}
                    </div>);
                if(item.isCallRecording){
                    urlHtm = (<a href={`${window.location.origin}${item.download}`} download>
                        {urlHtm}
                    </a>)
                }
            }
            return(
                <div className={style['data-list-holder']}>
                    <div className={style['data-list-title']}>
                        <span>{item.displaySourceName}</span> - <span className={style['data-list-type']}>{item.displayName}</span>
                    </div>
                    {urlHtm ? urlHtm : null}
                    {(item.uploadedBy || item.uploadedOn) ? (
                        <div className={style['data-list-meta']}>
                            {item.uploadedBy ? <span>Uploaded by: {item.uploadedBy}</span> : null}
                            {item.uploadedOn ? <span>Uploaded on: {item.uploadedOn}</span> : null}
                        </div>
                    ) : null}
                </div>
            )
        })
    }
    return (
            <SliderWrapper
                header={{
                    heading: 'Source Details',
                    variant: 'white',
                    className: style['add-edit-contractorsource-header'],
                    raised: scrolled,
                    leftIcons: [{
                        className: 'icon-hdrBackNew',
                        onClick: (e) => {
                             historyHandler.closeCurrent();
                        }
                   }],
                }}
                footer={{
                    btnProps: []
                }}
                slider = {{
                    className: style['add-edit-contractor-source-detail']
                }
                }
                updateScrollContRef={(scrollref) => {
                    setScrollEl(scrollref)
                }}
                onHidden={props.onHidden}
                isMobile = {props.isMobile}
            >
                <div className = {`${style['contractor-auditor-source-holder']} ${isContractorSourcev1 ? style['contractorv1-auditor-source-holder'] : ''}`}>
                    {websiteLink ? (
                        <div className={style['data-list-holder']}>
                            <div className={style['data-list-title']}>Website Link</div>
                            <div className={style['data-list-url']} onClick={() => onUrlClick(websiteLink)}>{websiteLink}</div>
                        </div>
                    ) : null}
                    {formElements}
                </div>
                {showPreview ? <DocumentPreview
                imageList = {previewImage}
                clickedImageIndex={0} 
                showHideCb = {showHideCb}
                ></DocumentPreview> : null}
            </SliderWrapper>   
    )
}

const mapStateToProps = state => {
	return {
        isMobile: state.deviceData.isMobile,
	};
};

export default connect(mapStateToProps,{
    showToastMessage: (payload) => {
        return (dispatch) => {
            dispatch(toastMessageActions.showMessage(payload))
        }
    }
    
})(ContractorSourceDetail);